export default {
  Signup: 'signup',
  Login: 'login',
  NewPassword: 'newPassword',
  ForgotPassword: 'forgotPassword',
  Phone: 'phone',
  About: 'about',
  Qualify: 'qualify',
  Business: 'business',
  SignupModal: 'signupModal',
  LaunchDate: 'launchDate',
  InstantPriceQuoteModal: 'instantPriceQuote'
}
